import Render from '@Views/root/statistics/aside-main.html'
import { Component, Vue } from 'vue-property-decorator'

@Render
@Component({})
export class ASideMain extends Vue {}